import configData from "./config.json";

const stage: "dev" | "prod" = (process.env.REACT_APP_STAGE as "dev" | "prod") || "dev";

// Get correct environment configuration
const config = configData[stage] || configData["dev"];

export default config;
